var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48793 7.09317C3.72393 7.37584 4.14393 7.4145 4.4266 7.1785L7.33327 4.7565V12.6665C7.33327 13.0345 7.63193 13.3332 7.99993 13.3332C8.36793 13.3332 8.6666 13.0345 8.6666 12.6665V4.7565L11.5733 7.1785C11.8566 7.4145 12.2766 7.37584 12.5119 7.09317C12.7479 6.8105 12.7099 6.38984 12.4266 6.1545L8.4266 2.82117C8.39527 2.7945 8.35793 2.78184 8.32327 2.76184C8.29593 2.74584 8.27193 2.72717 8.24193 2.71517C8.16393 2.6845 8.0826 2.6665 7.99993 2.6665C7.91727 2.6665 7.83593 2.6845 7.75793 2.71517C7.72793 2.72717 7.70393 2.74584 7.6766 2.76184C7.64193 2.78184 7.6046 2.7945 7.57327 2.82117L3.57327 6.1545C3.2906 6.38984 3.25193 6.8105 3.48793 7.09317"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.cf17f2ae.svg";
export { ForwardRef as ReactComponent };